import React from 'react';
import { useDashboardContext } from '../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import {
  faEdit,
  faPlus,
  faSave,
  faTimes,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons';
import Modal from '../../../../components/Modal';
import { useGetMessageGroupMembersMutation } from '../../../../features/authentication/messageApiSlice';
import PropTypes from 'prop-types';
import { faClipboardListCheck } from '@fortawesome/pro-solid-svg-icons';
import Skeleton from 'react-loading-skeleton';

const ManageDistList = ({ assignments, title, label, createButton, firstColumnTitle }) => {
  const {
    manageDis,
    setManageDist,
    setSelectRecipient,
    slectedStudents,
    allMessageGroup,
    createMessageGroup,
    updateMessageGroupName,
    setManageDisList,
    manageDisList,
    setSlectedGroupId,
    loadMessageGroupMembers,
    setSelectedGroupName,
    setSlectedStudents,
    deleteMessageGroup,
    isLoading
  } = useDashboardContext();
  const [getMessageGroupMembers] = useGetMessageGroupMembersMutation();
  const [craeteGroupName, setCraeteGroupName] = React.useState('');
  const [validationMsg, setValidationMsg] = React.useState('');
  const [groupNameChange, setGroupNameChange] = React.useState('');
  const [editIndex, setEditIndex] = React.useState(-1);

  const manageDisHandler = () => {
    if (manageDis)
      setValidationMsg('');
    setManageDist(!manageDis);
    setSelectRecipient(true);
  };

  const createGroupHandler = async () => {
    if (craeteGroupName !== '') {
      await createMessageGroup(craeteGroupName, []);
      setCraeteGroupName('');
      setValidationMsg('');
    } else {
      assignments
        ? setValidationMsg('Please enter a name for the group.')
        : setValidationMsg('Please enter a name for the distribution list.');
    }
  };

  const handleInputChange = (event) => {
    const { value } = event.target;
    setGroupNameChange(value);
  };

  const handleUpdateClick = (id) => {
    setEditIndex(-1);
    if (groupNameChange) {
      updateMessageGroupName(id, groupNameChange);
    }
  };

  const handleEditClick = (index, name) => {
    setEditIndex(index);
    setGroupNameChange(name);
  };

  const manageDisListHandler = (item) => {
    setManageDist(!manageDis);
    setManageDisList(!manageDisList);
    setSlectedGroupId(item.id);
    loadMessageGroupMembers(item.id);
    setSelectedGroupName(item.name);
  };

  const studentGroupHandler = async (id) => {
    setManageDist(!manageDis);
    setSelectRecipient(true);
    const allMessageGroupResponse = await getMessageGroupMembers(id).unwrap();
    const uniqueStudents = allMessageGroupResponse.filter((student) => {
      return !slectedStudents.some(
        (selectedStudent) => selectedStudent.studentId === student.studentId
      );
    });
    if (uniqueStudents.length === 0) {
      // Handle duplicate case here
      console.log('All selected students already exist in the list!');
    } else {
      // Add unique students to selectedStudents array
      setSlectedStudents((prevState) => [...prevState, ...uniqueStudents]);
    }
  };

  const groupDeleteHandler = (id) => {
    deleteMessageGroup(id);
  };

  return (
    <Modal isOpen={manageDis} titleName={title} onClose={manageDisHandler} contentWidth="100%">
      <div className="col-12 mb-4 create-distribution-list">
        <label className="form-label">{label}</label>
        <div className="d-flex">
          <input
            onChange={(event) => setCraeteGroupName(event.target.value)}
            value={craeteGroupName}
            type="text"
            className={assignments ? 'form-control col' : 'form-control'}
          />

          <button
            onClick={createGroupHandler}
            className="btn btn-castleRed ms-3 w-10"
            disabled={isLoading}>
            {createButton}
          </button>
        </div>
        {craeteGroupName === '' && validationMsg !== '' && (
          <div className="text-danger">{validationMsg}</div>
        )}
      </div>

      <div className="custom-table table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th>
                <strong>{firstColumnTitle}</strong>
              </th>
              {assignments && <th>Owner</th>}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {!isLoading ? (
              allMessageGroup?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {editIndex === index ? (
                        <input
                          className="form-control"
                          type="text"
                          value={groupNameChange}
                          onChange={(event) => handleInputChange(event, index)}
                        />
                      ) : (
                        item.name
                      )}
                    </td>
                    {assignments && <td>{item.owner}</td>}
                    <td>
                      <div className="action-btns d-flex justify-content-end gap-2">
                        {editIndex === index ? (
                          <>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top" className="custom-tooltip">
                                  Update
                                </Tooltip>
                              }>
                              <button onClick={() => handleUpdateClick(item.id)}>
                                {' '}
                                <FontAwesomeIcon icon={faSave} />
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top" className="custom-tooltip">
                                  Cancel
                                </Tooltip>
                              }>
                              <button onClick={() => setEditIndex(-1)}>
                                {' '}
                                <FontAwesomeIcon icon={faTimes} />
                              </button>
                            </OverlayTrigger>
                          </>
                        ) : (
                          <>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top" className="custom-tooltip">
                                  Rename
                                </Tooltip>
                              }>
                              <button onClick={() => handleEditClick(index, item.name)}>
                                {' '}
                                <FontAwesomeIcon icon={faEdit} />
                              </button>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top" className="custom-tooltip">
                                  View/Mange
                                </Tooltip>
                              }>
                              <button onClick={() => manageDisListHandler(item)}>
                                {' '}
                                <FontAwesomeIcon icon={faClipboardListCheck} />
                              </button>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top" className="custom-tooltip">
                                  Add
                                </Tooltip>
                              }>
                              <button
                                className="add_button"
                                onClick={() => studentGroupHandler(item.id)}>
                                {' '}
                                <FontAwesomeIcon color="#48E0B2" icon={faPlus} />
                              </button>
                            </OverlayTrigger>
                            <OverlayTrigger
                              placement="top"
                              overlay={
                                <Tooltip id="tooltip-top" className="custom-tooltip">
                                  Delete
                                </Tooltip>
                              }>
                              <button className="error delete_button">
                                {' '}
                                <FontAwesomeIcon
                                  onClick={() => groupDeleteHandler(item.id)}
                                  icon={faTrashAlt}
                                />
                              </button>
                            </OverlayTrigger>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <>
                {[...Array(5)].map((_, index) => (
                  <tr key={index}>
                    <td>
                      <Skeleton />
                    </td>
                    {assignments && <td><Skeleton /></td>}
                    <td>
                      <Skeleton />
                    </td>
                  </tr>
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>
      <div className="col-12 d-flex justify-content-end mt-3">
        <button onClick={manageDisHandler} className="btn btn-castleGray">
          Cancel
        </button>
      </div>
    </Modal>
  );
};

ManageDistList.propTypes = {
  assignments: PropTypes.bool,
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  createButton: PropTypes.string.isRequired,
  firstColumnTitle: PropTypes.string.isRequired
};

export default ManageDistList;
